const features = [
  { icon: 'ri-search-line', title: 'Marketplace Search', desc: 'Search and filter renewable energy products, services and providers across all categories.' },
  { icon: 'ri-scales-3-line', title: 'Comparison Tools', desc: 'Compare products, quotes and providers side by side with transparent data and real metrics.' },
  { icon: 'ri-calculator-line', title: 'Finance & ROI Calculators', desc: 'Estimate payback periods, savings and returns with built-in calculators tailored to Australian conditions.' },
  { icon: 'ri-dashboard-3-line', title: 'Customer Dashboard', desc: 'Track your enquiries, compare quotes and manage your renewable energy journey in one place.' },
  { icon: 'ri-group-line', title: 'Partner Portals', desc: 'Dedicated dashboards for installers, manufacturers and finance partners to manage enquiries and leads.' },
  { icon: 'ri-message-3-line', title: 'Messaging', desc: 'Communicate directly with providers, ask questions and negotiate through the platform.' },
  { icon: 'ri-file-text-line', title: 'Document Management', desc: 'Store quotes, warranties, certificates and installation documents securely in your account.' },
  { icon: 'ri-line-chart-line', title: 'Energy Monitoring', desc: 'Real-time monitoring of your solar generation, battery status and energy consumption patterns.' },
  { icon: 'ri-brain-line', title: 'Future AI Optimisation', desc: 'AI-powered recommendations to optimise energy usage, storage and participation in energy markets.' },
  { icon: 'ri-global-line', title: 'Future VPP Participation', desc: 'Join virtual power plant networks to earn revenue from your battery storage when connected to the grid.' },
];

export default function PlatformFeatures() {
  return (
    <section id="features" className="relative py-20 md:py-28 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 border border-primary-200/50 text-xs font-semibold tracking-wider uppercase text-primary-700 mb-5">
            Platform
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight max-w-3xl mx-auto" style={{ color: '#111827' }}>
            Built To Scale With The
            <span className="relative ml-2" style={{ color: '#2FA84F' }}>
              Energy Market
            </span>
          </h2>
          <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
            Powerful features designed for every participant in the renewable energy ecosystem.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((f, i) => (
            <div
              key={f.title}
              className="group bg-white rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-background-300 transition-all duration-300 hover:-translate-y-1 cursor-default"
              style={{ animationDelay: `${i * 60}ms` }}
            >
              <div className="w-10 h-10 rounded-lg bg-background-100 flex items-center justify-center mb-3 transition-colors group-hover:bg-primary-50">
                <i className={`${f.icon} text-primary-500 text-lg`}></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1.5">{f.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}